<script >

import bem from '@/utils/bem';
import HelpCenterHint from '@/components/helpCenters/helpCenterHint/Help-center-hint.vue';
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue';

const b = bem('help-center-category');

export default {
  components: {
    UpOutlined,
    DownOutlined,
    HelpCenterHint,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
    isFirst: {
      type: Boolean,
    },
    isLast: {
      type: Boolean,
    },
    changeOrder: {
      type: Function,
    },
    changeOrderHint: {
      type: Function,
    },
    onEdit: {
      type: Function,
    },
    onDelete: {
      type: Function,
    },
    withCreatedLink: {
      type: Boolean,
      default: false,
    },
    copyLinkToClipboard: {
      type: Function,
    },
  },
  data() {
    return {
      isShowList: false,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <div :class="b('wrapper', {isShowList})">
    <div :class="b('')">
      <div :class="b('title')">{{ category.title }}</div>
      <button
        :class="b('get-link')"
        v-if="withCreatedLink"
        @click="() => copyLinkToClipboard(category)"
      >
        Get link
      </button>
      <div :class="b('actions')">
        <a-button
          @click="() => {isShowList = !isShowList}"
        >
          {{isShowList ? 'Hide list' : 'Show list'}}
        </a-button>
      </div>
      <div :class="b('actions')">
        <a-button
          :class="b('order-button-up')"
          v-if="!isFirst"
          type="primary"
          html-type="button"
          @click="() => changeOrder('up')"
        >
          <template #icon>
            <UpOutlined />
          </template>
        </a-button>
        <a-button
          v-if="!isLast"
          type="primary"
          html-type="button"
          @click="() => changeOrder('down')"
        >
          <template #icon>
            <DownOutlined />
          </template>
        </a-button>
      </div>
      <div :class="b('actions')">
        <a-button
          type="primary"
          html-type="button"
          @click="() => onEdit(category)"
        >
          Edit
        </a-button>
        <a-button
          type="primary"
          html-type="button"
          danger
          @click="() => onDelete(category)"
        >
          Delete
        </a-button>
      </div>
    </div>
    <template
      v-if="isShowList"
    >
      <help-center-hint
        v-for="(hint, index) in category.helpCenters"
        :hint="hint"
        :isFirst="index === 0"
        :isLast="index === category.helpCenters.length - 1"
        :key="'hint-' + hint.id"
        :onEdit="() => onEdit(hint)"
        :onDelete="() => onDelete(hint)"
        :changeOrder="(changeType) => changeOrderHint({
          list: category.helpCenters,
          changeableItem: hint,
          changeType
        })"
        :withCreatedLink="withCreatedLink"
        :copyLinkToClipboard="copyLinkToClipboard"
      />
      <a-button
        :class="b('button')"
        type="primary"
        html-type="button"
        @click="() => onEdit({
        categoryId: category.categoryId
      })"
      >
        Create new hint
      </a-button>
    </template>
  </div>
</template>

<style scoped lang="scss">
  @import '@/styles/variables';
  @import "@/styles/media";

  .help-center-category {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 100px;
    height: 90px;
    background-color: $jagged_ice;
    padding: 10px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(100);
    }

    &__wrapper {
      display: flex;
      flex-direction: column;
      gap: 10px;

      @include mediaMinMax(1025, $normal) {
        gap: vw-full(10);
      }

      &_isShowList {
        box-shadow: 10.1px 12.4px 76px 0 rgba(0,0,0,.07);
        background-color: $jagged_ice;
        padding: 0 10px 10px;

        @include mediaMinMax(1025, $normal) {
          padding: 0 vw-full(10) vw-full(10);
        }
      }
    }

    &__title {
      flex-grow: 1;
    }

    &__actions {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    &__button {
      width: fit-content;
      margin: 0 auto;
      gap: 30px;

      @include mediaMinMax(1025, $normal) {
        gap: vw-full(30);
      }
    }

    &__get-link {
      display: flex;
      border: none;
      background: $tacao;
      color: $ebony-clay-gray-color;
      text-transform: uppercase;
      padding: 10px 15px;
      border-radius: 5px;

      @include mediaMinMax(1025, $normal) {
        padding: vw-full(5);
        border-radius: vw-full(5);
      }
    }
  }
</style>
